import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01154217"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "signup-widget__success",
  alt: "Success",
  src: "https://dce5jani6jm7e.cloudfront.net/data/icons/form-success.svg"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "signup-widget__ebook"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adm_typography = _resolveComponent("adm-typography")!
  const _component_AdmButton = _resolveComponent("AdmButton")!
  const _component_adm_card = _resolveComponent("adm-card")!

  return (_openBlock(), _createBlock(_component_adm_card, { class: "signup-widget__form" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_adm_typography, {
        color: "secondary",
        variant: "subtitle1",
        class: "signup-widget__title"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("TYpageSignUpForm.all-ty-signup-intro-1")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_adm_typography, {
        color: "secondary",
        variant: "body1",
        class: "signup-widget__content"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("TYpageSignUpForm.all-ty-signup-p-1")), 1)
        ]),
        _: 1
      }),
      (_ctx.ebook)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_adm_typography, {
              color: "secondary",
              variant: "body1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("TYpageSignUpForm.all-ty-signup-ebook")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_AdmButton, {
              id: "download-ebook",
              class: "signup-widget__button",
              trailingIcon: "chevron_right",
              href: "https://admiralfiles.s3.amazonaws.com/books/Admiral-Markets-eBook-Your-Roadmap-to-Trading-and-Investing-UK-Apr-25.pdf"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("TYpageSignUpForm.all-ty-signup-ebook-cta")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}